export const DEFAULT_DEFERRED_ORDER_API_URL =
    'https://shop.api.openticket.tech/';

// Can likely be removed, leaving just in case an error needs to be shown.
// type OrderMessage = {
//     parentOf?: DeferredOrderMessage;
//     subjectType?: string;
//     guid?: string;
//     reservation?: string;
//     reason?: string;
// };

export interface DeferredAddition {
    pollintervalms?: number;
    polllimit?: number;
}

export interface Order extends DeferredAddition {
    // amount: null | number;
    // errors: DeferredOrderMessage[];
    // fatals: DeferredOrderMessage[];
    // notices: DeferredOrderMessage[];
    order_id: string;
    redirectUrl: string;
}

export interface DeferredOrder extends DeferredAddition {
    deferred: boolean;
    sub: string;
}

export function isDeferredOrder(order: unknown): order is DeferredOrder {
    return (
        !!order &&
        typeof order === 'object' &&
        isDeferredAddition(order) &&
        'deferred' in order &&
        typeof order.deferred === 'boolean' &&
        'sub' in order &&
        typeof order.sub === 'string'
    );
}

export function isDeferredAddition(
    addition: unknown
): addition is DeferredAddition {
    return (
        !!addition &&
        typeof addition === 'object' &&
        (!('pollintervalms' in addition) ||
            typeof addition.pollintervalms === 'number') &&
        (!('polllimit' in addition) || typeof addition.polllimit === 'number')
    );
}

export function isOrder(order: unknown): order is Order {
    return (
        !!order &&
        typeof order === 'object' &&
        isDeferredAddition(order) &&
        'order_id' in order &&
        typeof order.order_id === 'string' &&
        'redirectUrl' in order &&
        typeof order.redirectUrl === 'string'
    );
}
